module.exports = __webpack_public_path__ + "img/icn_send.85b99152.svg";